"use strict";module.exports = {
  _N_: new WeakMap(),
  _M_: new WeakMap(),
  _r_: new WeakMap(),
  aY_: new WeakMap(),
  _p_: new WeakMap(),
  _q_: {}
};